<script>
  import { domainName, record, lookupBimiFound, lookupBimiDmarcFound } from '../stores.js';
  import BIMIResultLogo from './bimiResultLogo.svelte';
  import BIMIResultRaw from './bimiResultRaw.svelte';
  import BIMIResultAdditional from './bimiResultAdditional.svelte';
  import ContactUsForm from '../ContactUsForm.svelte';
  import BIMIResultNotFound from './bimiResultNotFound.svelte';
  // import BIMIShare from './bimiShare.svelte';
  import Sidebar from '../Sidebar.svelte';

  let modifyBimi = false;

  // Function to refresh the page
  function refreshPage(event) {
    event.preventDefault(); // Prevents the default anchor behavior
    location.reload(); // Reloads the page
  }
</script>

<section class="tool-banner tool-banner-bimi mb-5">
  <div class="banner"></div>
  <div class="row-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-12 m-auto banner-text">
          <h2>View BIMI Record</h2>
          <p>Put your trusted logo on the email your customers receive.</p>
          <button on:click={() => window.location.reload()} class ="refresh-page" title="Look Up or Generate BIMI Record">Search New Domain</button><i class="fa-solid fa-arrows-rotate"></i>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8 m-auto">
          <div class="result-box">
            <div class="found">
              {#if $lookupBimiDmarcFound}
                <ul class="result-heading record-found">
                  <li><h3>DMARC Record Found: {$domainName}</h3></li>
                  <li><h3>DMARC Record Policy: {$domainName}</h3></li>
                </ul>
              {:else}
                <ul class="result-heading no-record-found">
                  <li><h3>DMARC Record Not Found: {$domainName}</h3></li>
                </ul>
              {/if}
              {#if $lookupBimiFound}
                <ul class="result-heading record-found">
                  <li><h3>BIMI Record Found: {$domainName}</h3></li>
                </ul>
              {:else}
                <ul class="result-heading no-record-found">
                  <li><h3>BIMI Record Not Found: {$domainName}</h3></li>
                </ul>
              {/if}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="record record-bimi">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        {#if $lookupBimiFound}
          <BIMIResultLogo />
          <BIMIResultRaw />
          <BIMIResultAdditional />

          <div class="btn-wrap">
            <button on:click|preventDefault={() => modifyBimi = true} disabled={modifyBimi} class="btn btn-1 btn-lg" id="modify-bimi">Modify BIMI Record</button>
            <a href="/resources/dmarc" class="btn btn-1 btn-lg" title="Look Up or Generate DMARC Record">Create DMARC Record</a>
          </div>

          {#if modifyBimi}
            <div class="record-box bimi-modify-form">
              <div id="headingRaw" class="box-label">
                <h5>Modify BIMI Record</h5>
                <button type="button" class="btn-collapse" data-toggle="collapse" data-target="#collapseModify" aria-expanded="true" aria-controls="collapseModify" aria-label="Close"></button>
              </div>
              <div id="collapseModify" class="box-detail" aria-labelledby="headingRaw">
                <ContactUsForm />
              </div>
            </div>
          {/if}
        {:else}
          <BIMIResultNotFound />
        {/if}
      </div>


    </div>
  </div>
</section>

<style>
  .result-heading li {
    margin-bottom: 1rem;
  }
</style>
